import { UNIT } from '../../constants/theme';

export const styles = () => ({
  listOptions: {
    maxHeight: UNIT * 12.7,
    marginTop: UNIT * 0.625,
    borderRadius: UNIT,
    overflow: 'auto',
    border: '1px gray solid',
    position: 'relative',
    padding: UNIT,
  },
  title: {
    fontSize: UNIT * 0.9375,
  },
  checkboxList: {
    display: 'flex',
    cursor: 'pointer',
    marginRight: 0,
    margin: '-15px 0px -15px -10px'
  },
  descriptionStyle: {
    fontSize: UNIT * 0.5625,
    marginTop: 0,
    width: '100%',
    textAlign: 'center',
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  hrStyle: {
    width: '100%',
    borderBottom: '0.1px solid #999999',
    marginBottom: '0px',
  },
  selectedList: {
    marginLeft: `${UNIT * 0.5625}px!important`,
    fontWeight: 'bolder',
    marginBottom: `${-UNIT * 0.5}px!important`,
  },
  optionName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  indexStyle: {
    margin: UNIT * 0.625
  }
});